import { RESET_PDF_GEN_ACTIVITY, SET_CONFIGURATION_SETTINGS, SET_PDF_GEN_ACTIVITY } from '@state-management/constants';
import { Action } from '../actions';
import { IPDFComponentStatus, mergePdfGeneratorState, pdfDefaultValues } from '../utils/pdf-configuration';

export type { IPDFComponentStatus } from '../utils/pdf-configuration';
export { pdfDefaultValues } from '../utils/pdf-configuration';

export interface ConfigurationReducerState {
  menu: unknown[];
  pdf_generator: IPDFComponentStatus;
}

const initialState: ConfigurationReducerState = {
  menu: [],
  pdf_generator: { ...pdfDefaultValues },
};

export function ConfigurationReducer(state = initialState, action: Action): ConfigurationReducerState {
  switch (action.type) {
    case SET_CONFIGURATION_SETTINGS: {
      const data = action.payload?.data;
      return { ...state, menu: (data as unknown[]) ?? [] };
    }
    case SET_PDF_GEN_ACTIVITY: {
      const payload = action.payload;
      const data = (payload?.data as IPDFComponentStatus) ?? pdfDefaultValues;
      const deviceHints = payload?.deviceHints;
      return { ...state, pdf_generator: mergePdfGeneratorState(data, deviceHints) };
    }
    case RESET_PDF_GEN_ACTIVITY: {
      return { ...state, pdf_generator: { ...pdfDefaultValues } };
    }
    default: {
      return state;
    }
  }
}

export const getConfigurationMenu = (state: ConfigurationReducerState) => state.menu;
export const getPdfGeneratorActivity = (state: ConfigurationReducerState) => state.pdf_generator;
